/**
 * v10 문서 분류 스키마 (31-class + 6-group) — 프론트용 ES 모듈 복제본
 * ─────────────────────────────────────────────────────────────────
 * Source of truth: backend/distillation/config/docTypeSchema.js
 * 변경 시 양쪽을 함께 수정할 것.
 * ↳ drift 감지 테스트: backend/distillation/config/docTypeSchema.test.js 의
 *   "frontend/backend schema drift 없음" 테스트가 코드/그룹/prefix 를 비교함.
 */

export const DOC_TYPES = {
  CI:            { group: 'primary',     label: 'Commercial Invoice / 인보이스',                    prefix: 'INV' },
  PL:            { group: 'primary',     label: 'Packing List / 팩킹리스트',                         prefix: 'PAK' },
  COMBINED:      { group: 'primary',     label: 'Invoice + Packing 혼합',                            prefix: 'COMB' },

  BL:            { group: 'supporting',  label: 'Bill of Lading / AWB / HAWB / MAWB',               prefix: 'BL' },
  THROUGH_BL:    { group: 'supporting',  label: '통과선하증권 (Through B/L)',                        prefix: 'THRUBL' },
  CO:            { group: 'supporting',  label: '원산지증명서 / Certificate of Origin',              prefix: 'CO' },
  FTA:           { group: 'supporting',  label: 'FTA Certificate',                                   prefix: 'FTA' },
  NONPROC:       { group: 'supporting',  label: '비가공증명서 / 재화청단',                           prefix: 'NONPROC' },
  FREIGHT_INV:   { group: 'supporting',  label: '운임인보이스 (포워더/운송사)',                      prefix: 'FREIGHT' },
  DO_NOTICE:     { group: 'supporting',  label: 'D/O 발급확인서 (H-D/O · House D/O)',                prefix: 'DONOTC' },

  BIZREG:        { group: 'party',       label: '사업자등록증',                                      prefix: 'BIZREG' },
  AGENCY:        { group: 'party',       label: '수입대행계약서',                                    prefix: 'AGENCY' },
  TRANSFER:      { group: 'party',       label: '양도양수증',                                        prefix: 'TRANSFER' },
  CUSTOMS_POA:   { group: 'party',       label: '통관고유부호위임장',                                prefix: 'POA' },
  CONTRACT:      { group: 'party',       label: 'Sales Contract / PO',                               prefix: 'CONTRACT' },
  INSURANCE:     { group: 'party',       label: '적하보험증권 / Insurance',                          prefix: 'INS' },

  KC:            { group: 'requirement', label: 'KC 인증서',                                         prefix: 'KC' },
  EXEMPT_CONF:   { group: 'requirement', label: '요건면제확인서',                                    prefix: 'EXEMPT' },
  CUSTOMS_CONF:  { group: 'requirement', label: '세관장 확인물품 확인증',                            prefix: 'CUSTCONF' },
  CONFORM_CERT:  { group: 'requirement', label: '적합성평가확인서',                                  prefix: 'CONFORM' },
  CHEM_DECL:     { group: 'requirement', label: '화학물질확인명세서',                                prefix: 'CHEM' },
  STD_REPORT:    { group: 'requirement', label: '표준통관예정보고서',                                prefix: 'STDREP' },

  REDUCTION_APP: { group: 'exemption',   label: '관세감면신청서',                                    prefix: 'REDUCE' },
  USAGE_DESC:    { group: 'exemption',   label: '용도설명서',                                        prefix: 'USAGE' },
  DOMESTIC_REC:  { group: 'exemption',   label: '국내제작곤란품목 추천서',                           prefix: 'DOMREC' },
  BOND_GUAR:     { group: 'exemption',   label: '개별담보제공서 / 재수출',                           prefix: 'BOND' },
  RD_CERT:       { group: 'exemption',   label: '기업부설연구소 인증서',                             prefix: 'RDCERT' },

  IMPORT_DECL:   { group: 'result',      label: '수입신고필증',                                      prefix: 'IMPORT_DECL' },
  EXPORT_DECL:   { group: 'result',      label: '수출신고필증',                                      prefix: 'EXPORT_DECL' },

  DELIV_CHANGE:  { group: 'admin',       label: '배송지 주소 변경 요청서',                           prefix: 'DELIV' },
  STATEMENT:     { group: 'admin',       label: '사유서',                                            prefix: 'STMT' },
  TAX_DECISION:  { group: 'admin',       label: '과세결정자료',                                      prefix: 'TAX' },
  OTHER:         { group: 'admin',       label: '커버/백지/필기/분류불가',                           prefix: 'OTHER' },
};

export const DOC_GROUP_ORDER = ['supporting', 'primary', 'party', 'requirement', 'exemption', 'result', 'admin'];

export const GROUP_META = {
  supporting:  { label: '운송·원산지 (B/L · CO · FTA)',         section: 'source',  color: 'slate' },
  primary:     { label: '핵심 상업서류 (INV · PAK · COMB)',      section: 'source',  color: 'blue'  },
  party:       { label: '관계·계약 (사업자·계약·보험)',          section: 'source',  color: 'slate' },
  requirement: { label: '요건확인 (KC · 화학 · 적합성)',         section: 'source',  color: 'slate' },
  exemption:   { label: '감면·담보 (감면신청·재수출담보)',        section: 'source',  color: 'slate' },
  result:      { label: '신고 결과 (신고필증)',                  section: 'result',  color: 'slate' },
  admin:       { label: '행정·기타 (배송지·사유서·OTHER)',        section: 'result',  color: 'slate' },
};

export const TYPE_CODES = Object.keys(DOC_TYPES);

export function groupOf(code)  { return (DOC_TYPES[code] && DOC_TYPES[code].group)  || 'admin'; }
export function labelOf(code)  { return (DOC_TYPES[code] && DOC_TYPES[code].label)  || code; }
export function prefixOf(code) { return (DOC_TYPES[code] && DOC_TYPES[code].prefix) || code; }

export function compareDocTypes(a, b) {
  const ga = DOC_GROUP_ORDER.indexOf(groupOf(a));
  const gb = DOC_GROUP_ORDER.indexOf(groupOf(b));
  if (ga !== gb) return ga - gb;
  return TYPE_CODES.indexOf(a) - TYPE_CODES.indexOf(b);
}

/**
 * 페이지 배열을 doc_type 기준으로 그룹핑 + PREFIX_N 라벨 부여.
 * 반환: [{ group: {key, label, prefix, groupKey, groupLabel}, items: [{...page, label}] }]
 */
export function groupPagesByDocType(pages) {
  if (!Array.isArray(pages) || pages.length === 0) return [];
  const buckets = new Map();
  for (const p of pages) {
    const code = DOC_TYPES[p.doc_type] ? p.doc_type : 'OTHER';
    if (!buckets.has(code)) buckets.set(code, []);
    buckets.get(code).push(p);
  }
  const codes = [...buckets.keys()].sort(compareDocTypes);
  return codes.map(code => {
    const arr = buckets.get(code).sort((a, b) => (a.page || 0) - (b.page || 0));
    const items = arr.map((p, i) => ({ ...p, label: `${prefixOf(code)}_${i + 1}` }));
    return {
      group: {
        key: code,
        label: DOC_TYPES[code].label,
        prefix: prefixOf(code),
        groupKey: groupOf(code),
        groupLabel: (GROUP_META[groupOf(code)] || {}).label || groupOf(code),
      },
      items,
    };
  });
}
